// This character is mixed in with firefox drag and drop data and must be removed. It is non ascii however and will
// git with any file that it is in, so it is kept here in its own file.
export const firefoxNonAsciiRegEx = / /gi
